// extracted by mini-css-extract-plugin
export default {"container":"OrderFunction_container__5lbfn","title":"OrderFunction_title__mcbp1","subTitle":"OrderFunction_subTitle__tigM-"};